import type { FC, SVGProps } from "react";

const Close: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="initial"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="close icon">
      {/* <title>close icon</title> */}
      <path
        d="M15.6081 13.9961C16.0766 14.4646 16.0766 15.2248 15.6081 15.6934C15.1395 16.162 14.3793 16.162 13.9107 15.6934L8.00156 9.74027L2.05039 15.6914C1.58185 16.16 0.821649 16.16 0.353057 15.6914C-0.115535 15.2229 -0.115485 14.4627 0.353057 13.9941L6.30623 8.04494L0.351407 2.04876C-0.117135 1.58022 -0.117135 0.820017 0.351407 0.351425C0.819948 -0.117167 1.58015 -0.117117 2.04874 0.351425L8.00156 6.3496L13.9527 0.398434C14.4213 -0.0701078 15.1815 -0.0701078 15.6501 0.398434C16.1187 0.866976 16.1186 1.62718 15.6501 2.09577L9.69689 8.04494L15.6081 13.9961Z"
        fill={props.fill}
      ></path>
    </svg>
  );
};

export default Close;
